import { c as _c } from "react/compiler-runtime";
import { ArrowDownOnSquareIcon } from '@heroicons/react/24/solid';
import { GithubLogo } from '@/frontend/design-system/_marketing/logos/socials/GithubLogo';
import { LinkedinLogo } from '@/frontend/design-system/_marketing/logos/socials/LinkedinLogo';
import { YoutubeLogo } from '@/frontend/design-system/_marketing/logos/socials/YoutubeLogo';
import { Avatar } from '@/frontend/design-system/actions/Avatar';
import { Button } from '@/frontend/design-system/actions/Button';
import { Link } from '@/frontend/design-system/actions/Link';
import { LightCard } from '@/frontend/design-system/data-display/Card';
import { H1 } from '@/frontend/design-system/typography/Heading';
import { P2 } from '@/frontend/design-system/typography/Paragraph';
import { ScrollToContactButton } from './ScrollToContactButton';
type TeacherCardProps = {
  name: string;
  aboutMe: string;
  photoUrl?: string;
  cvUrl?: string;
  socials: {
    githubUrl?: string;
    linkedinUrl?: string;
    youtubeUrl?: string;
  };
  email?: string;
};
export function TeacherCard(t0) {
  const $ = _c(33);
  const {
    name,
    aboutMe,
    photoUrl,
    cvUrl,
    socials
  } = t0;
  let t1;
  if ($[0] !== photoUrl) {
    t1 = photoUrl && <div className="h-40 w-40 shrink-0 sm:h-60 sm:w-60"><Avatar src={photoUrl} imageResolution={240} className="h-full w-full object-cover" /></div>;
    $[0] = photoUrl;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== name) {
    t2 = <H1>{name}</H1>;
    $[2] = name;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== aboutMe) {
    t3 = <P2 className="text-contentSecondary">{aboutMe}</P2>;
    $[4] = aboutMe;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t2 || $[7] !== t3) {
    t4 = <div className="flex flex-col items-center gap-4 lg:items-start">{t2}{t3}</div>;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <ScrollToContactButton />;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== cvUrl) {
    t6 = cvUrl && <Button marketing={true} marketingVariant="outline" href={cvUrl} target="_blank"><ArrowDownOnSquareIcon />Pobierz CV</Button>;
    $[10] = cvUrl;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t6) {
    t7 = <div className="flex w-full flex-col gap-3 sm:w-fit sm:flex-row">{t5}{t6}</div>;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== socials.githubUrl) {
    t8 = socials.githubUrl && <Link href={socials.githubUrl} target="_blank"><GithubLogo className="size-9 rounded-full bg-backgroundBlue py-1.5 text-algoprimary" /></Link>;
    $[14] = socials.githubUrl;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== socials.linkedinUrl) {
    t9 = socials.linkedinUrl && <Link href={socials.linkedinUrl} target="_blank"><LinkedinLogo className="size-9 rounded-full bg-backgroundBlue py-1.5 text-algoprimary" /></Link>;
    $[16] = socials.linkedinUrl;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== socials.youtubeUrl) {
    t10 = socials.youtubeUrl && <Link href={socials.youtubeUrl} target="_blank"><YoutubeLogo className="size-9 rounded-full bg-backgroundBlue py-1.5 text-algoprimary" /></Link>;
    $[18] = socials.youtubeUrl;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== t10 || $[21] !== t8 || $[22] !== t9) {
    t11 = <div className="flex flex-row items-center space-x-3">{t8}{t9}{t10}</div>;
    $[20] = t10;
    $[21] = t8;
    $[22] = t9;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== t11 || $[25] !== t7) {
    t12 = <div className="flex flex-col items-center gap-6 sm:flex-row sm:justify-between">{t7}{t11}</div>;
    $[24] = t11;
    $[25] = t7;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  if ($[27] !== t12 || $[28] !== t4) {
    t13 = <div className="flex flex-col gap-6">{t4}{t12}</div>;
    $[27] = t12;
    $[28] = t4;
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  let t14;
  if ($[30] !== t1 || $[31] !== t13) {
    t14 = <LightCard className="mx-auto flex h-auto w-full max-w-[50rem] flex-col items-center gap-6 p-6 shadow-sm lg:flex-row">{t1}{t13}</LightCard>;
    $[30] = t1;
    $[31] = t13;
    $[32] = t14;
  } else {
    t14 = $[32];
  }
  return t14;
}